import { Skeleton } from '@/components/ui/Skeleton';

export default function BookSkeleton() {
  return (
    <div className="flex flex-col gap-5">
      <Skeleton className="mx-auto h-96 w-4/5 rounded-xl" />
      <div className="rounded-xl border border-coal-200 bg-white p-5">
        <div className="mb-4 border-b border-coal-200 pb-4">
          <Skeleton className="h-6 w-28 rounded" />
          <Skeleton className="mt-3 h-4 w-64 rounded" />
          <Skeleton className="mt-2 h-4 w-52 rounded" />
          <Skeleton className="mt-2 h-4 w-48 rounded" />
          <Skeleton className="mt-2 h-4 w-56 rounded" />
        </div>
        <div>
          <Skeleton className="h-6 w-28 rounded" />
          <Skeleton className="mt-3 h-4 w-64 rounded" />
          <Skeleton className="mt-2 h-4 w-52 rounded" />
          <Skeleton className="mt-2 h-4 w-48 rounded" />
          <Skeleton className="mt-2 h-4 w-56 rounded" />
        </div>
      </div>
      <Skeleton className="h-10 rounded-lg" />
    </div>
  );
}
